var websock = null;
let currentWsUrl = null; // 最近一次连接地址（visibilitychange 恢复时复用）
let isConnect = false; // 连接标识，避免重复连接
let isConnecting = false; // 连接建立中标识，避免并发创建双连接
let kickedByServer = false; // 被服务端踢出标记（cmd=2）：关闭后禁止自动重连，避免互踢循环
let manuallyClosed = false; // 主动 close() 标记（封禁/退出）：禁止 visibilitychange 自动重连
let connectCallBack = null;
let messageCallBack = null;
let closeCallBack = null;

// 发送消息最大重试次数
const SEND_MAX_RETRY = 5;

// 连接时实时读取最新 token（HTTP 刷新后 sessionStorage 已更新，重连自动使用新 token）
let connect = (wsurl) => {
	try {
		if (isConnect || isConnecting) {
			return;
		}
		isConnecting = true;
		kickedByServer = false; // 新连接开始，清除上次被踢状态
		manuallyClosed = false;
		currentWsUrl = wsurl;
		let accessToken = sessionStorage.getItem("accessToken") || "";
		let url = wsurl + '?token=' + accessToken;
		websock = new WebSocket(url);
		websock.onmessage = function (e) {
			// 收到任何服务端帧都说明连接存活：刷新心跳调度并取消僵死检测
			// （放在 JSON.parse 之前，单条坏数据也不会破坏心跳闭环）
			heartCheck.reset();
			let sendInfo;
			try {
				sendInfo = JSON.parse(e.data);
			} catch (err) {
				console.warn('[WS] 忽略无法解析的服务端帧:', e.data);
				return;
			}
			if (sendInfo.cmd == 0) {
				// 连接成功
				connectCallBack && connectCallBack();
			} else if (sendInfo.cmd == 1) {
				// 心跳响应帧（服务端对 cmd=1 回复确认，reset 已刷新存活判定）
			} else if (sendInfo.cmd == 2) {
				// 被异地登录踢出：置标志，onclose 时跳过自动重连（避免两台设备互踢循环）
				kickedByServer = true;
				messageCallBack && messageCallBack(sendInfo.cmd, sendInfo.data);
			} else {
				messageCallBack && messageCallBack(sendInfo.cmd, sendInfo.data);
			}
		};
		websock.onclose = function (e) {
			isConnect = false;
			isConnecting = false;
			heartCheck.stop();
			// 被服务端踢出（cmd=2）：不触发重连回调（Home.vue 会弹强制下线并跳转登出）。
			// 标志保留到下次 connect 重置，visibilitychange 分支同样据此跳过重连
			if (kickedByServer) {
				return;
			}
			closeCallBack && closeCallBack(e);
		};
		websock.onopen = function () {
			isConnect = true;
			isConnecting = false;
			let loginInfo = {
				cmd: 0,
				data: {
					accessToken: accessToken
				}
			};
			websock.send(JSON.stringify(loginInfo));
		};
		websock.onerror = function (e) {
			isConnect = false;
			isConnecting = false;
		};
	} catch (e) {
		isConnecting = false;
		closeCallBack && closeCallBack({ code: -1 });
	}
};

let close = (code) => {
	manuallyClosed = true; // 主动关闭：visibilitychange 不再自动重连（封禁弹窗等场景）
	heartCheck.stop();
	websock && websock.close(code);
};

// 页面恢复可见时（后台标签页 timer 被浏览器节流，心跳/僵死检测可能停滞）：
// 连接已关闭则立即重连（不等被节流的退避定时器）；连接存活则立即补发心跳，
// 刷新服务端读超时窗口，避免"切回页面才发现连接已断/反复重连"的体验
document.addEventListener('visibilitychange', () => {
	if (document.hidden) return;
	if (!websock) return;
	if (websock.readyState === WebSocket.CLOSED) {
		// 被服务端踢出或主动关闭（封禁弹窗等）后不自动重连
		if (!kickedByServer && !manuallyClosed) {
			connect(currentWsUrl);
		}
	} else if (websock.readyState === WebSocket.OPEN) {
		heartCheck.start();
	}
});

// 心跳设置
// 服务端不回复 cmd=1，故以“收到任意服务端帧”作为连接存活证据：
// 发送心跳后 waitTimeout 内若无任何帧（reset 未触发），判定半开连接僵死，主动断开触发重连补偿
let heartCheck = {
	timeout: 5000,      // 心跳发送间隔
	waitTimeout: 10000, // 僵死检测等待：发送心跳后该时间内无任何帧则主动断开
	timeoutObj: null,   // 心跳发送定时器
	waitObj: null,      // 僵死检测定时器
	start: function () {
		if (isConnect) {
			// 先清旧定时器再发心跳：visibilitychange 等路径直连调用 start 时，
			// 若残留上一个 waitObj，其到点会误判僵死并关闭仍健康的连接
			clearTimeout(this.timeoutObj);
			clearTimeout(this.waitObj);
			let heartBeat = {
				cmd: 1,
				data: {}
			};
			websock.send(JSON.stringify(heartBeat));
			this.waitObj = setTimeout(() => {
				console.warn('[WS] 心跳超时无响应，判定连接僵死，主动断开');
				websock && websock.close();
			}, this.waitTimeout);
		}
	},
	reset: function () {
		clearTimeout(this.timeoutObj);
		clearTimeout(this.waitObj);
		this.timeoutObj = setTimeout(function () {
			heartCheck.start();
		}, this.timeout);
	},
	stop: function () {
		clearTimeout(this.timeoutObj);
		clearTimeout(this.waitObj);
	}
};

// 发送消息（带最大重试限制）
let sendMessage = (agentData, retryCount = 0) => {
	if (!websock || retryCount >= SEND_MAX_RETRY) {
		console.error('[WS] 发送消息失败：连接不可用或超过最大重试次数');
		return;
	}
	if (websock.readyState === websock.OPEN) {
		websock.send(JSON.stringify(agentData));
	} else if (websock.readyState === websock.CONNECTING || websock.readyState === websock.CLOSING) {
		setTimeout(function () {
			sendMessage(agentData, retryCount + 1);
		}, 1000);
	} else {
		console.error('[WS] 发送消息失败：连接已关闭');
	}
};

let onConnect = (callback) => {
	connectCallBack = callback;
};

let onMessage = (callback) => {
	messageCallBack = callback;
};

let onClose = (callback) => {
	closeCallBack = callback;
};

export {
	connect,
	close,
	sendMessage,
	onConnect,
	onMessage,
	onClose,
};
